import { render } from "./WelcomeToPlanDialog.vue?vue&type=template&id=64fce7b6&scoped=true"
import script from "./WelcomeToPlanDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeToPlanDialog.vue?vue&type=script&lang=js"

import "./WelcomeToPlanDialog.vue?vue&type=style&index=0&id=64fce7b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fce7b6"]])

export default __exports__